import { action } from 'typesafe-actions';
import { GiroWebappError } from '../../../model/error';
import { ProgramToList } from '../../../model/program';
import { ListProgramsActionTypes } from './types';

export const listProgramsRequest = (limit?: number) => action(ListProgramsActionTypes.LIST_PROGRAMS_REQUEST, limit);
export const listProgramsSuccess = (programs: ProgramToList[]) => action(ListProgramsActionTypes.LIST_PROGRAMS_SUCCESS, programs);
export const listProgramsError = (error: GiroWebappError) => action(ListProgramsActionTypes.LIST_PROGRAMS_ERROR, error);
